export default class NineSlicePlane extends PIXI.NineSlicePlane{
  constructor(data) {
    const texture = PIXI.Texture.from(`${data.from}`)
    super(texture, window.innerWidth, 0, window.innerWidth, 0)
    this._data = data
    this.width = window.innerWidth * 10
    this.height = this._data.height * 2
  }
}
